<template>
  <default-layout>
    <section slot="content">
      <v-container fluid>
        <v-row justify="center" class="mt-10" v-if="order && order.client">
          <template>
            <v-col cols="12">
              <div>
                <v-alert
                  class="order-alert"
                  border="left"
                  colored-border
                  color="success"
                  elevation="0"
                >
                  <div class="d-flex align-center">

                    <v-avatar
                      color="success"
                      size="54"
                      class="mr-4"
                    >
                      <v-icon dark>
                        mdi-package-check
                      </v-icon>
                    </v-avatar>

                    <div>
                      <div class="order-alert-title">
                        Pedido registrado correctamente
                      </div>

                      <div class="order-alert-subtitle">
                        N° Pedido:
                        <span class="order-number">
                          {{ zfill(order.id, 9) + '-' + order.client_id }}
                        </span>
                      </div>

                      <div class="order-alert-subtitle">
                        Nos contactaremos con usted para validar la compra.
                      </div>
                    </div>

                  </div>

                  <v-divider class="my-4"></v-divider>

                  <template v-if="order.payment_type_id == 1">
                    <strong>Pago mediante Yape:</strong> 987839662
                  </template>

                  <template v-else-if="order.payment_type_id == 2">
                    <strong>Transferencia Bancaria</strong><br><br>

                    <strong>INTERBANK SOLES</strong><br>
                    8983313913343<br>
                    Sayda Cuaresma Olarte<br><br>

                    <strong>BCP SOLES</strong><br>
                    194-94958085-0-54<br>
                    Sayda Cuaresma Olarte
                  </template>

                  <template v-else>
                    <strong>Pago Contra Entrega</strong>
                  </template>
                </v-alert>
              </div>
            </v-col>
          </template>
          <v-col cols="12" md="10" xs="12">
            <v-row justify="center">
              <v-col cols="12" lg="4" md="12" sm="12" xs="12">
                <template>
                  <v-card
                    class="info-card"
                  >
                    <v-card-text>
                      <p class="section-title">
                        Datos Personales
                      </p>
                      <div class="text--primary">
                        {{ order.client.name }} {{ order.client.last_name }}<br>
                        {{ order.client.identification_doc }}<br>
                        {{ order.client.phone }}<br>
                      </div>
                    </v-card-text>
                  </v-card>
                </template>
              </v-col>

              <v-col cols="12" lg="4" md="12" sm="12" xs="12">
                <template>
                  <v-card
                    class="info-card"
                  >
                    <v-card-text>
                      <p class="section-title">
                        Medio de Pago
                      </p>
                      <div class="text--primary">
                        <template v-if="order.payment_type_id == 1">
                          YAPE<br>
                        </template>
                        <template v-else-if="order.payment_type_id == 2">
                          Transferencia Bancaria<br>
                        </template>
                        <template v-else>
                          Pago Contra Entrega<br>
                        </template>
                        <div class="total-highlight">
                          S/ {{ order.total }}
                        </div>
                      </div>
                    </v-card-text>
                  </v-card>
                </template>
              </v-col>

              <v-col cols="12" lg="4" md="12" sm="12" xs="12">
                <template>
                  <v-card
                    class="info-card"
                  >
                    <v-card-text>
                      <p class="section-title">
                        Resumen de Compra
                      </p>
                      <div class="text--primary">
                        <v-row no-gutters>
                          <v-col cols="6" md="6" sm="5" xs="6">
                            <v-card class="body-2 text-left" style="border: 0px" outlined elevation="0">
                              Subtotal
                            </v-card>
                          </v-col>
                          <v-col cols="6" md="6" sm="3" xs="6">
                            <v-card class="body-2 text-right" style="border: 0px" outlined elevation="0">
                              S/ {{ order.subtotal }}
                            </v-card>
                          </v-col>
                          <v-col cols="6" md="6" sm="5" xs="6">
                            <v-card class="body-2 text-left" style="border: 0px" outlined elevation="0">
                              Envío
                            </v-card>
                          </v-col>
                          <v-col cols="6" md="6" sm="3" xs="6">
                            <v-card class="body-2 text-right" style="border: 0px" outlined elevation="0">
                              S/ {{ order.shipping_price }}
                            </v-card>
                          </v-col>
                          <template v-if="order.coupon > 0">
                            <v-col cols="6" md="6" sm="3" xs="6">
                              <v-card class="body-2 text-left" style="border: 0px" outlined elevation="0">
                                Cupón
                              </v-card>
                            </v-col>
                            <v-col cols="6" md="6" sm="3" xs="6">
                              <v-card class="body-2 text-right" style="border: 0px" outlined elevation="0">
                                - S/ {{ order.coupon }}
                              </v-card>
                            </v-col>
                          </template>
                          <v-col cols="12" sm="12">
                            <v-card-title primary-title>
                              <v-divider></v-divider>
                            </v-card-title>
                          </v-col>
                          <v-col cols="6" md="6" sm="5" xs="6">
                            <v-card class="body-1 text-left" style="border: 0px" outlined elevation="0">
                              <strong>Total</strong>
                            </v-card>
                          </v-col>
                          <v-col cols="6" md="6" sm="3" xs="6">
                            <v-card class="body-1 text-right" style="border: 0px" outlined elevation="0">
                              <span class="total-highlight">
                                S/ {{ order.total }}
                              </span>
                            </v-card>
                          </v-col>
                        </v-row>
                      </div>
                    </v-card-text>
                  </v-card>
                </template>
              </v-col>

              <v-col cols="12" lg="4" md="12" sm="12" xs="12">
                <template>
                  <v-card
                    class="info-card"
                  >
                    <v-card-text>
                      <p class="section-title">
                        Recepción
                      </p>
                      <div class="text--primary">
                        <template v-if="order.person_reception == 1">
                          {{ order.client.name }} {{ order.client.last_name }}<br>
                          {{ order.client.identification_doc }}<br>
                        </template>
                        <template v-else>
                          {{ order.name_reception }} {{ order.last_name_reception }}<br>
                          {{ order.identification_doc_reception }}<br>
                        </template>
                        {{ order.address.address }}<br>
                        {{ order.address.reference }}
                      </div>
                    </v-card-text>
                  </v-card>
                </template>
              </v-col>

              <v-col cols="12" lg="4" md="12" sm="12" xs="12">
                <template>
                  <v-card
                    class="info-card"
                  >
                    <v-card-text>
                      <p class="section-title">
                        Programada
                      </p>
                      <div class="text--primary">
                        {{ formatDate(order.delivery_day) }}
                      </div>
                    </v-card-text>
                  </v-card>
                </template>
              </v-col>

              <v-col cols="12" lg="8" md="12" sm="12" xs="12">
                <v-card class="products-card">
                  <v-virtual-scroll :items="orderDetail" :item-height="112" :height="heightScroll" style="overflow-y: auto !important">
                    <template v-slot="{ item }">

                      <div class="product-row">

                        <div class="product-image">

                          <v-badge
                            color="primary"
                            overlap
                            :content="item.quantity"
                          >
                            <v-avatar
                              tile
                              size="80"
                            >
                              <v-img
                                :src="item.product_color.product_color_image[0].image"
                              />
                            </v-avatar>
                          </v-badge>

                        </div>

                        <div class="product-content">

                          <div>
                            {{ item.product.name }}
                          </div>

                        </div>

                        <div>
                          S/ {{ item.amount }}
                        </div>

                      </div>

                    </template>
                  </v-virtual-scroll>
                </v-card>
              </v-col>

            </v-row>
          </v-col>
        </v-row>
      </v-container>
    </section>
  </default-layout>
</template>
<script>
  import DefaultLayout from '@/layouts/DefaultLayout'
  import axios from 'axios'
  import moment from 'moment'

  export default {
    name: 'OrderDetail',
    components: {
      DefaultLayout
    },
    data () {
      return {
        order: {},
        orderDetail: []
      }
    },
    computed: {
      key () {
        return (localStorage.getItem('orderNumber') ? localStorage.getItem('orderNumber') : null);
      },

      heightScroll () {
        if (this.orderDetail.length > 5) {
          return 549;
        } else {
          return 112 * this.orderDetail.length;
        }
      }
    },
    methods: {
      getOrder () {
        axios.get(process.env.DINO.PATH.FIND_ORDER_DETAIL.replace(':orderNumber', this.key))
        .then(response => {
          this.order = response.data.order;
          this.orderDetail = response.data.orderDetail;
        })
        .catch(err => {
        });
      },

      formatDate: function(date) {
        moment.locale('es');
        let newDate = moment(date, 'yyyy-MM-DD');
        return 'Para ' + moment(newDate).format('DD') + ' de ' + moment(newDate).format('MMMM') + ' de ' + moment(newDate).format("yyyy");
      },

      zfill: function(number, width) {
        var numberOutput = Math.abs(number);
        var length = number.toString().length;
        var zero = "0";

        if (width <= length) {
            if (number < 0) {
                 return ("-" + numberOutput.toString());
            } else {
                 return numberOutput.toString();
            }
        } else {
            if (number < 0) {
                return ("-" + (zero.repeat(width - length)) + numberOutput.toString());
            } else {
                return ((zero.repeat(width - length)) + numberOutput.toString());
            }
        }
      }
    },
    mounted: function () {
      if (localStorage.getItem('orderNumber')) {
        this.getOrder();
      } else {
        this.$router.push({ name: 'OrderTrackingLogin' })
      }
    }
  }
</script>
<style scoped>
.v-container {
  background: #f8fafc;
}

.info-card {
  border-radius: 18px;
  border: 1px solid #e2e8f0;
  box-shadow: 0 4px 16px rgba(15, 23, 42, 0.05) !important;
  transition: all .2s ease;
  height: 100%;
}

.info-card:hover {
  transform: translateY(-2px);
}

.section-title {
  font-size: 1.25rem;
  font-weight: 700;
  color: #1e293b;
  margin-bottom: 16px;
}

.section-content {
  color: #475569;
  line-height: 1.8;
}

.order-alert {
  border-radius: 20px;
}

.order-alert-title {
  font-size: 20px;
  font-weight: 700;
  color: #0f172a;
}

.order-alert-subtitle {
  color: #64748b;
  margin-top: 4px;
}

.order-number {
  color: #2563eb;
  font-weight: 700;
}

.total-highlight {
  font-size: 26px;
  font-weight: 700;
  color: #2563eb;
}

.products-card {
  border-radius: 18px;
  border: 1px solid #e2e8f0;
  overflow: hidden;
}

.product-row {
  display: flex;
  align-items: center;
  padding: 18px;
  border-bottom: 1px solid #f1f5f9;
}

.product-row:last-child {
  border-bottom: 0;
}

.product-image {
  width: 90px;
  min-width: 90px;
}

.product-content {
  flex: 1;
  padding: 0 16px;
}

.product-name {
  font-size: 14px;
  font-weight: 600;
  color: #1e293b;
  line-height: 1.5;
}

.product-price {
  font-size: 18px;
  font-weight: 700;
  color: #2563eb;
  white-space: nowrap;
}

.summary-row {
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
}

.summary-label {
  color: #64748b;
}

.summary-value {
  font-weight: 600;
  color: #1e293b;
}

.divider-space {
  margin: 16px 0;
}

@media (max-width: 600px) {

  .order-alert-title {
    font-size: 17px;
  }

  .product-row {
    padding: 12px;
  }

  .product-image {
    width: 70px;
    min-width: 70px;
  }

  .product-content {
    padding: 0 10px;
  }

  .product-name {
    font-size: 13px;
  }

  .product-price {
    font-size: 15px;
  }

  .total-highlight {
    font-size: 22px;
  }
}

</style>



// WEBPACK FOOTER //
// src/views/OrderTrackingDetail.vue